module.exports = __webpack_public_path__ + "img/点击查看360°全景.png";